"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export const red: string = '#c61a1b';
// export const darkRed: string = '#ab1a1c';
exports.green = '#30ae33';
/*
export const black: string = '#0a0a0a';
export const darkGray: string = '#595453';
export const gray: string = '#828282';
export const lightGray: string = '#b0b0b0';
export const extraLightGray: string = '#cacaca';
export const offWhite: string = '#f1f1f1';
*/
exports.white = '#FFFFFF';
exports.gray = '#ABABAB';
exports.offWhite = '#E9E9E9';
exports.black = '#262626';
exports.extraLightRed = '#D63434';
exports.lightRed = '#C61A1B';
exports.red = '#8F0808';
exports.darkRed = '#4F0E13';
exports.extraDarkRed = '#230808';
exports.emsBlue = '#1d2ec2';
exports.infoOrange = '#f5a623';
exports.policeBlue = '#001d5f';
exports.waterBlue = '#54bdec';
function getOverlayFontColor(bgColor) {
    var bigint = parseInt(bgColor.replace('#', ''), 16);
    var r = (bigint >> 16) & 255;
    var g = (bigint >> 8) & 255;
    var b = bigint & 255;
    var a = 1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return a < 0.4 ? exports.black : exports.offWhite;
}
exports.getOverlayFontColor = getOverlayFontColor;
